import { observer } from 'mobx-react'
import React, { useContext } from 'react'
import { StoreContext } from '../../../components/App'
import { Circle, InfoPage } from './enroll.styles'
import IconError from '../../../assets/icon_error.svg'

export const NotFound = observer(() => {
  const store = useContext(StoreContext)

  const {
    enrollCompanyPage: { notFound: trans },
  } = store.TranslationsState.translations

  return (
    <InfoPage>
      <main>
        <h1>{trans.title}</h1>
        <Circle>
          <img src={IconError} alt="Error" />
        </Circle>
        <h2>{trans.description}</h2>
      </main>
    </InfoPage>
  )
})
